export function channelLabel(channel) {
  if (channel === "lounge") return "Lounge";
  if (channel === "fixture") return "Match";
  return "Chat";
}

export function bodyTypeLabel(type) {
  if (type === "poll") return "Poll";
  if (type === "bond_wheel") return "Wheel";
  return "Message";
}

export function previewText(item, max = 64) {
  const text = String(item?.body?.text || "").trim();
  if (!text) return "No text content";
  if (text.length <= max) return text;
  return `${text.slice(0, max)}…`;
}

export function formatReportWhen(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";

  const now = Date.now();
  const diffMs = now - date.getTime();
  const diffMin = Math.floor(diffMs / 60000);

  if (diffMin < 1) return "Just now";
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 7) return `${diffDay}d ago`;

  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function reportHeatPct(item) {
  if (!item?.reportedAt) return 72;
  const ageHours = (Date.now() - new Date(item.reportedAt).getTime()) / 3600000;
  if (ageHours < 1) return 100;
  if (ageHours < 6) return 92;
  if (ageHours < 24) return 78;
  return 62;
}

export function authorInitials(name = "") {
  const trimmed = name.trim();
  if (!trimmed) return "??";
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function queueSubline(item) {
  const parts = [bodyTypeLabel(item?.body?.type), previewText(item, 48)];
  if (item?.fixtureLabel) parts.push(item.fixtureLabel);
  return parts.filter(Boolean).join(" · ");
}
